/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис для генерации и хранения приватных и публичных ключей, в данном случае необходимых для подписи токена, находится в DMZ зоне, непосредственно не участвует в сценариях Партнёра
 */

/**
 * Сервис KMS
 */
export class KmsServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод генерации пары ключей.
   * Генерирует публичный и приватный ключи.
   * Приватный ключ шифруется алгоритмом AES-GCM и сохранятеся в колонке kms.key_infos.encrypted_private_key.
   * Формат хранения приватного ключа - строковое представление JSON: состоит из переменных:
   * - Nonce: Number used once - представляет собой уникальный набор битов, используется один раз при шифровании блока данных в режиме GCM.
   * - EncryptedString: зашифрованный приватный ключ в формате DER.
   * - Tag: Message Authentication Code, используется для проверки целостности и подлинности данных после их расшифровки.
   * Публичный ключ сохранятеся в колонке kms.key_infos.public_key в формате DER и передаётся в сервис JWKS методом PostKey.
   * Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695357.
   * Метод доступен для: admin, manager, service
   */
  PostKmsKeyGenerate = (req?: PostKmsKeyGenerateRequestDto, init?: RequestInit): Promise<PostKmsKeyGenerateResponseDto> => {
    return fm.request<PostKmsKeyGenerateRequestDto, PostKmsKeyGenerateResponseDto>(`${this.host}/kms/internal/api/v1/kms/key/generate`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения ключей.
   * Возвращает три последних ключа отсортированных по created_at DESC.
   * Используется в административном интерфейсе, для отображения даты выпуска последней пары ключей.
   * Сценарий использвания: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.
   * Метод доступен для: admin, manager, service
   */
  GetKmsKeyList = (req?: GetKmsKeyListRequestDto, init?: RequestInit): Promise<GetKmsKeyListResponseDto[]> => {
    return fm.list<GetKmsKeyListRequestDto, GetKmsKeyListResponseDto>(`${this.host}/kms/internal/api/v1/kms/key/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
}

/**
 * Запрос на получение ключей
 */
export type GetKmsKeyListRequestDto = {
}
/**
 * Ответ на запрос на получение ключей
 */
export type GetKmsKeyListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ключ.
   * В ключе должен отсутсвовать encrypted_private_key
   */
  readonly data: KeyInfoResponseDto
}>
/**
 * Пара ключей.
 * # Описание модели
 */
export type KeyInfoRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Пара ключей.
 * # Описание модели
 */
export type KeyInfoResponseDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
  /**
   * Публичный ключ.
   * # Диапазон: 0..800
   */
  readonly publicKey: string
  /**
   * Приватный ключ в зашифрованном виде.
   * # Диапазон: 0..4000
   */
  readonly encryptedPrivateKey: string
  /**
   * Дата и время создания ключа
   */
  readonly createdAt: string
  /**
   * Дата и время истечения жизни ключа
   */
  readonly expiredAt: string | null
}
/**
 * Ошибка генерации
 */
export type KeyInfoGeneratingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка генерации ключа в сервисе KMS
   */
  readonly transaction: KeyInfoGeneratingErrorTransactionErrorRequestDto
  /**
   * Ошибка сохранения публичного ключа в сервисе JWKS
   */
  readonly publishing: KeyInfoGeneratingErrorPublishingKeyErrorRequestDto
}>
/**
 * Ошибка генерации
 */
export type KeyInfoGeneratingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка генерации ключа в сервисе KMS
   */
  readonly transaction: KeyInfoGeneratingErrorTransactionErrorResponseDto
  /**
   * Ошибка сохранения публичного ключа в сервисе JWKS
   */
  readonly publishing: KeyInfoGeneratingErrorPublishingKeyErrorResponseDto
}>
/**
 * Ошибка сохранения публичного ключа в сервисе JWKS.
 * Причины:
 * - Отсутсвует связанность с сервисом JWKS
 */
export type KeyInfoGeneratingErrorPublishingKeyErrorRequestDto = {
}
/**
 * Ошибка сохранения публичного ключа в сервисе JWKS.
 * Причины:
 * - Отсутсвует связанность с сервисом JWKS
 */
export type KeyInfoGeneratingErrorPublishingKeyErrorResponseDto = {
}
/**
 * Ошибка генерации ключа в сервисе KMS.
 * Причины:
 * - Отсутсвует связанность с базой данных
 */
export type KeyInfoGeneratingErrorTransactionErrorRequestDto = {
}
/**
 * Ошибка генерации ключа в сервисе KMS.
 * Причины:
 * - Отсутсвует связанность с базой данных
 */
export type KeyInfoGeneratingErrorTransactionErrorResponseDto = {
}
/**
 * Запрос на генерацию пары ключей
 */
export type PostKmsKeyGenerateRequestDto = {
}
/**
 * Ответ на запрос на генерацию пары ключей
 */
export type PostKmsKeyGenerateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  readonly data: string
  /**
   * Ошибка
   */
  readonly error: PostKmsKeyGenerateResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostKmsKeyGenerateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка генерации ключей в сервисе KMS
   */
  readonly generating: KeyInfoGeneratingErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostKmsKeyGenerateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка генерации ключей в сервисе KMS
   */
  readonly generating: KeyInfoGeneratingErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на получение ключей
   */
  "GetKmsKeyListRequest": {
    "kind": "class",
    "text": "Запрос на получение ключей",
  },
  /**
   * Ответ на запрос на получение ключей
   */
  "GetKmsKeyListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение ключей",
    "fields": {
      /**
       * Ключ.
       * В ключе должен отсутсвовать encrypted_private_key
       */
      "data": {
        "type": "KeyInfo",
        "text": "Ключ.\nВ ключе должен отсутсвовать encrypted_private_key",
      },
    },
  },
  /**
   * Пара ключей.
   * # Описание модели
   */
  "KeyInfo": {
    "kind": "class",
    "text": "Пара ключей.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Публичный ключ.
       * # Диапазон: 0..800
       */
      "publicKey": {
        "type": "string",
        "text": "Публичный ключ.\n# Диапазон: 0..800",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 800,
            "message": "Значение не входит в допустимый диапазон. Максимум: 800"
          },
        }
      },
      /**
       * Приватный ключ в зашифрованном виде.
       * # Диапазон: 0..4000
       */
      "encryptedPrivateKey": {
        "type": "string",
        "text": "Приватный ключ в зашифрованном виде.\n# Диапазон: 0..4000",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 4000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4000"
          },
        }
      },
      /**
       * Дата и время создания ключа
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время создания ключа",
      },
      /**
       * Дата и время истечения жизни ключа
       */
      "expiredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время истечения жизни ключа",
      },
    },
  },
  /**
   * Ошибка генерации
   */
  "KeyInfo.GeneratingError": {
    "kind": "class",
    "text": "Ошибка генерации",
    "fields": {
      /**
       * Ошибка генерации ключа в сервисе KMS
       */
      "transaction": {
        "type": "KeyInfo.GeneratingError.TransactionError",
        "text": "Ошибка генерации ключа в сервисе KMS",
      },
      /**
       * Ошибка сохранения публичного ключа в сервисе JWKS
       */
      "publishing": {
        "type": "KeyInfo.GeneratingError.PublishingKeyError",
        "text": "Ошибка сохранения публичного ключа в сервисе JWKS",
      },
    },
  },
  /**
   * Ошибка сохранения публичного ключа в сервисе JWKS.
   * Причины:
   * - Отсутсвует связанность с сервисом JWKS
   */
  "KeyInfo.GeneratingError.PublishingKeyError": {
    "kind": "class",
    "text": "Ошибка сохранения публичного ключа в сервисе JWKS.\nПричины:\n- Отсутсвует связанность с сервисом JWKS",
  },
  /**
   * Ошибка генерации ключа в сервисе KMS.
   * Причины:
   * - Отсутсвует связанность с базой данных
   */
  "KeyInfo.GeneratingError.TransactionError": {
    "kind": "class",
    "text": "Ошибка генерации ключа в сервисе KMS.\nПричины:\n- Отсутсвует связанность с базой данных",
  },
  /**
   * Запрос на генерацию пары ключей
   */
  "PostKmsKeyGenerateRequest": {
    "kind": "class",
    "text": "Запрос на генерацию пары ключей",
  },
  /**
   * Ответ на запрос на генерацию пары ключей
   */
  "PostKmsKeyGenerateResponse": {
    "kind": "class",
    "text": "Ответ на запрос на генерацию пары ключей",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "data": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostKmsKeyGenerateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostKmsKeyGenerateResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка генерации ключей в сервисе KMS
       */
      "generating": {
        "type": "KeyInfo.GeneratingError",
        "text": "Ошибка генерации ключей в сервисе KMS",
      },
    },
  },
}